<template>
  <a-modal :visible="visible" :closable="false">
    <h6 class="mt-2 text-center">
      Bulk Print {{ actionType === 'print-picking-list' ? 'Picking List' : 'Shipping Label' }}
    </h6>
    <a-tag v-for="fulfillment in filterCheckedOrder" :key="fulfillment.order_number" class="my-1" color="blue">
      {{ fulfillment.order_number }}
    </a-tag>
    <a-divider class="my-2" />
    <div>Total: {{ filterCheckedOrder.length }} order</div>
    <template #footer>
      <a-button key="back" :loading="loading" class="mr-2" @click="closeModal()">
        Batalkan
      </a-button>
      <a-button key="submit" :loading="isProcessing" type="primary" @click="submitModal()">
        Print
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { getFulfillmentDetailByOrder } from '@/api/fulfillment'

export default {
  name: 'ModalBulkPrintShippingLabel',
  props: {
    visible: Boolean,
    back: Function,
    loading: Boolean,
    listFulfillment: Array,
    actionType: String,
    businessId: [String, Number],
  },
  data() {
    return {
      localLoading: false,
      resolvedFulfillmentIds: [],
    }
  },
  computed: {
    filterCheckedOrder() {
      return this.listFulfillment.filter(fulfillment => fulfillment.is_checked)
    },
    isProcessing() {
      return this.loading || this.localLoading
    },
  },
  watch: {
    visible(val) {
      if (val && this.actionType === 'print-shipping-label') {
        this.fetchOldestFulfillmentIds()
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('handleShowModal', false)
      this.resolvedFulfillmentIds = []
    },
    async fetchOldestFulfillmentIds() {
      this.localLoading = true
      try {
        const selectedOrders = this.filterCheckedOrder
        const promises = selectedOrders.map(async (f) => {
          try {
            const { data: { data: orderData } } = await getFulfillmentDetailByOrder({
              business_id: this.businessId,
              order_id: f.order_id,
           })
            const sorted = [...orderData.fulfillments].sort((a, b) => a.created_at - b.created_at)
            return sorted[0].id
          } catch (e) {
            console.error(`Failed to fetch fulfillment for order ${f.order_id}`, e)
            return f.fulfillment_id
          }
        })
        this.resolvedFulfillmentIds = await Promise.all(promises)
      } catch (err) {
        console.error(err)
      } finally {
        this.localLoading = false
      }
    },
    submitModal() {
      if (this.isProcessing) return
      
      const ids = this.resolvedFulfillmentIds.length > 0 
        ? this.resolvedFulfillmentIds.join(',')
        : this.filterCheckedOrder.map(f => f.fulfillment_id).join(',')

      this.$emit('handleSubmitModal', ids)
      this.closeModal()
    },
  },
}
</script>

<style lang="scss" module>
</style>